import BaseInput from "./BaseInput";
import TextInput from "./variants/TextInput";
import EmailInput from "./variants/EmailInput";
import PhoneInput from "./variants/PhoneInput";

// Create the compound component
const Input = Object.assign(BaseInput, {
    Text: TextInput,
    Email: EmailInput,
    Phone: PhoneInput
});

export default Input;
